export const preloadState = (initialState, preloaders) => {
  let state = {}

  Object.keys(preloaders).map(key => {
    state[key] = preloaders[key](initialState)
  })

  return state
}